import styled from 'styled-components';
import { GREY_800, GREY_400, GREY_200 } from '../../constants';

export const SummaryItemContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 1.5rem;
    text-align: center;
`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-right: 1rem;
    gap: 0.35rem;
`;

export const Value = styled.h1`
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1.875rem;
    text-align: left;
    white-space: nowrap;
    color: ${GREY_800};
`;

export const Label = styled.p`
    font-size: 0.9375rem;
    font-weight: 400;
    line-height: 1.375rem;
    text-align: left;
    white-space: nowrap;
    color: ${GREY_400};
`;

export const Footer = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9375rem;
    font-weight: 300;
    line-height: 1.375rem;
    color: ${GREY_200};
`;

export const IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    padding-top: 0.4rem;

`;
